import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { sidebar as admin_list_items } from './admin/listItems';
import { sidebar as merchant_list_items } from './merchant/listItems';
import { sidebar as riderListItems } from './rider/listItems';
import Container from '@material-ui/core/Container';
import { useStore, useSelector } from 'react-redux';
import AdminContainer from './admin';
import MerchantContainer from './merchant';
import RiderContainer from './rider';
import Box from '@material-ui/core/Box';
import { Copyright } from '../../components/copyright';
import ToolBar from './Toolbar';
import { SidebarListLogout } from '../../components/sidebar-list-logout';
import MerchantProfile from './MerchantProfile';

const drawerWidth = 200;
const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    width: '100%',
    flexGrow: 1,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
  },
  container: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  hidePrint: {},
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
}));

export default function Dashboard() {
  const store = useStore();
  const classes = useStyles();
  const userRole = store.getState().auth?.user?.role?.name;
  // eslint-disable-next-line
  const [get_width, set_width] = React.useState(window.innerWidth);

  const open = useSelector((state: any) => state?.dashboard?.isOpen); // Define the type of the state object

  // eslint-disable-next-line
  const [get_drawer_variant, set_drawer_variant]: [any, any] = React.useState(() =>
    get_width > 600 ? 'persistent' : 'temporary',
  );

  const handleDrawerClose = () => {
    store.dispatch({ type: 'CLOSE_SIDEBAR' });
  };

  function sidebar_based_on_role(role: string) {
    if (store.getState()?.auth?.user?.confirmed) {
      if (role === 'admin') {
        return admin_list_items;
      }
      if (role === 'merchant') {
        return merchant_list_items;
      }
      if (role === 'rider') {
        return riderListItems;
      }
    }
    return '';
  }
  function dashboard_based_on_role(role: string) {
    if (store.getState()?.auth?.user?.confirmed) {
      if (role === 'admin') {
        return <AdminContainer />;
      }

      if (role === 'merchant') {
        return <MerchantContainer />;
      }

      if (role === 'rider') {
        return <RiderContainer />;
      }
    }
    return (
      <Container maxWidth="lg" className={classes.container}>
        Welcome to {process.env.REACT_APP_COURIER_COMPANY_NAME} <br />
        Please contact <a href="tel:+8801407705777">01407-705777</a> for your account verification.
        <br />
        After verification please logout and login again.
      </Container>
    );
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        style={{ zIndex: 1 }}
        position="absolute"
        className={clsx(classes.appBar, get_width > 600 && open && classes.appBarShift, classes.hidePrint)}
      >
        <ToolBar open={open} />
      </AppBar>
      <Drawer
        variant={get_drawer_variant}
        anchor="left"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose, classes.hidePrint),
        }}
        open={open}
        onClose={handleDrawerClose}
      >
        <div className="flex items-center justify-end px-2 h-16">
          <b>{process.env.REACT_APP_COURIER_COMPANY_NAME}</b>
          <IconButton size="medium" onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        {userRole == 'merchant' && (
          <>
            <Divider />
            <MerchantProfile />
          </>
        )}
        <Divider />
        <List onClick={() => get_width <= 600 && handleDrawerClose()}>
          {sidebar_based_on_role(userRole)}
          <SidebarListLogout />
        </List>
      </Drawer>
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: get_width > 600 && open,
        })}
      >
        <div className="flex items-center justify-end px-4 h-16" />
        {/* child containers are inside this dashboard function here */}
        {dashboard_based_on_role(userRole)}
        <Box pt={4}>
          <Copyright />
        </Box>
      </main>
    </div>
  );
}
